import { render, staticRenderFns } from "./new-video.vue?vue&type=template&id=36eb9ede&scoped=true"
import script from "./new-video.vue?vue&type=script&lang=js"
export * from "./new-video.vue?vue&type=script&lang=js"
import style0 from "./new-video.vue?vue&type=style&index=0&id=36eb9ede&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eb9ede",
  null
  
)

export default component.exports